/* eslint-disable @typescript-eslint/no-explicit-any */
import type Highcharts from "highcharts";

declare module "highcharts" {
  export class Navigator {
    chart: Highcharts.Chart;
  }
}

// if you plan to modify this
// test, test and test again (money click creating/modifying analyses changing charts like crazy)
export default function fixNavigatorSeriesUpdate(H: typeof Highcharts) {
  H.wrap(
    H.Series.prototype,
    "removeEvents",
    function (
      this: Highcharts.Series,
      proceed: {
        apply: (...args: unknown[]) => void;
      },
      ...args: unknown[]
    ) {
      // do not crash when deleting series twice (second time through navigator destroy)

      if ((this as any).eventsToUnbind === undefined) {
        // eslint-disable-next-line no-console
        console.warn("missing eventsToUnbind", this);

        (this as any).eventsToUnbind = [];
      }
      proceed.apply(this, args);
    },
  );

  H.wrap(
    H.Series.prototype,
    "destroy",
    function (
      this: Highcharts.Series,
      proceed: {
        apply: (...args: unknown[]) => void;
      },
      ...args: unknown[]
    ) {
      // do not crash when deleting series twice (second time through navigator destroy)
      // our custom navigator series also belong to the base chart
      if (!this.chart) return;
      return proceed.apply(this, args);
    },
  );

  H.wrap(
    H.Navigator.prototype,
    "setBaseSeries",
    function (
      this: any,
      _: {
        apply: (...args: unknown[]) => void;
      },
      ...args: unknown[]
    ) {
      if (args[1] === false) return;
      const chart = this.chart,
        baseSeries: any[] = (this.baseSeries = []);

      const baseSeriesOptions =
        args[0] ||
        chart.options?.navigator.baseSeries ||
        chart.series.find((s: any) => !s.options.isInternal)?.index || // HERE IS THE DIFF
        0;
      // Iterate through series and add the ones that should be shown in
      // navigator.

      // eslint-disable-next-line unicorn/no-array-for-each
      (chart.series || []).forEach((series: any, i: number) => {
        if (
          // Don't include existing nav series
          !series.options.isInternal &&
          (series.options.showInNavigator ||
            ((i === baseSeriesOptions || series.options.id === baseSeriesOptions) &&
              series.options.showInNavigator !== false))
        ) {
          baseSeries.push(series);
        }
      });
      // When run after render, this.xAxis already exists
      if (this.xAxis && !this.xAxis.navigatorAxis.fake) {
        this.updateNavigatorSeries(true, args[1]);
      }
    },
  );

  H.wrap(
    (H as any).seriesTypes.column.prototype,
    "redraw",
    function (
      this: Highcharts.Series,
      proceed: {
        apply: (...args: unknown[]) => void;
      },
      ...args: unknown[]
    ) {
      if (this.xAxis.options === undefined) {
        const xAxis = this.chart.xAxis.find(x => x.options.id === "navigator-x-axis")!;
        this.xAxis.options = xAxis.options;
      }
      if (this.yAxis.options === undefined) {
        const yAxis = this.chart.yAxis.find(x => x.options.id === "navigator-y-axis")!;
        this.yAxis.options = yAxis.options;
      }
      return proceed.apply(this, args);
    },
  );
}
